export const defaultColumnOrder: string[] = [
  'name',
  'commentCount',
  'contractId',
  'dba',
  'invoiceStatus',
  'billingStatus',
  'type',
  'invoiceOption',
  'agreementOption',
  'startDate',
  'endDate',
  'organizations',
  'dealStatus',
  'reasonChurn',
  'lastDateOfService',
  'churnNote',
  'contractedBy',
  'id',
  'creation_timestamp',
  'stage',
  'lastModified',
  'timeCompleted',
  'amId',
  'billingContact',
  'primaryContact',
  'implementationFee',
  'total',
]
